import { trpcUnbatchedClient } from '@/api/trpc';
import { useAppQuery } from '@/hooks/useAppQuery';
import type { AssetSessionPrices } from '@einhaus/project314-types';

export function useAssetSessionPrices(symbols: string[]) {
    const normalizedSymbols = [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))].sort();

    return useAppQuery<AssetSessionPrices[], Error, AssetSessionPrices[], [string, string[]]>({
        queryKey: ['assetSessionPrices', normalizedSymbols],
        queryFn: async () => {
            const prices: AssetSessionPrices[] = [];
            for (let offset = 0; offset < normalizedSymbols.length; offset += 100) {
                const response = await trpcUnbatchedClient.entity.fetchAssetSessionPrices.query({
                    symbols: normalizedSymbols.slice(offset, offset + 100)
                });
                prices.push(...response.prices);
            }
            return prices;
        },
        enabled: normalizedSymbols.length > 0,
        staleTime: 15000,
        refetchInterval: 30000
    });
}
